function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 50,
  height: 50
}, React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "url(#paint0_linear)"
}), React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "url(#paint1_linear)",
  fillOpacity: 0.5
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M16.8 9H32.8L36 23.4H13.6L16.8 9Z",
  fill: "white"
}), React.createElement("path", {
  d: "M15.2 27.6H24.8H34.4C34.4 30.2508 32.251 32.4 29.6 32.4C26.949 32.4 24.8 30.2508 24.8 27.6C24.8 30.2508 22.651 32.4 20 32.4C17.349 32.4 15.2 30.2508 15.2 27.6Z",
  fill: "black",
  fillOpacity: 0.8
}), React.createElement("path", {
  d: "M11.9999 35.6H22L24.8 42V50H15L3.5 41.6L15.7844 39.8575L11.9999 35.6Z",
  fill: "white"
}), React.createElement("path", {
  d: "M37.6001 35.6H27.6L24.8 42V51H36L46.5 41.6L34.0414 39.8816L37.6001 35.6Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.8 25V21.8H13.6L16.8 9H32.8L36 21.8H40.8V25H8.8ZM32.7015 21.8L30.3015 12.2H19.2985L16.8985 21.8H32.7015Z",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 50,
  y1: 102.632,
  x2: -45.5412,
  y2: 76.4597,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F1B2FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#77C6FF"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 25,
  y1: 0,
  x2: 25,
  y2: 50,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#F0F0F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 36,
  y1: 7.9751e-7,
  x2: 9.5,
  y2: 47.5,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#D0CBFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8F9BFF"
})));

var SvgAvatar = function SvgAvatar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar.8695cda7.svg";
export { ForwardRef as ReactComponent };